import React, { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext"; // if you track user login
import { QuoteContext } from "./QuoteContext";
const QuoteSuccess = () => {
  const { user } = useContext(AuthContext); // optional, for "View My Quotes" button
  const navigate = useNavigate();
const { quoteItems } = useContext(QuoteContext);
  // Optional: clear quote cart or reset state
  useEffect(() => {
    localStorage.removeItem("quoteItems"); // or your cart context logic
  }, []);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">

          {/* Success Message */}
          <div className="text-center mb-5">
            <div
              className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
              style={{ width: 80, height: 80 }}
            >
              <i className="fa-solid fa-check fa-2x"></i>
            </div>
            <h1 className="text-success fw-bold mb-3">
              Your quote request has been successfully submitted!
            </h1>
            <p className="lead text-muted">
              Thank you for your bulk/imprinting quote request. We have received your information and will respond within 24 hours during business days.
            </p>
          </div>

          {/* What Happens Next */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">
                <i className="fa-solid fa-clock me-2"></i>What Happens Next?
              </h4>
            </div>
            <div className="card-body">
              <div className="row">
                {[
                  {
                    number: "1",
                    bg: "bg-primary",
                    title: "Review & Analysis",
                    text: "Our team will review your quote request and analyze your imprinting requirements."
                  },
                  {
                    number: "2",
                    bg: "bg-success",
                    title: "Custom Quote Preparation",
                    text: "We'll prepare a detailed quote with pricing, timeline, and imprinting options."
                  },
                  {
                    number: "3",
                    bg: "bg-warning",
                    title: "Response Within 24 Hours",
                    text: "You'll receive a comprehensive quote response via email within 24 hours."
                  },
                  {
                    number: "4",
                    bg: "bg-info",
                    title: "Follow-up & Discussion",
                    text: "Our team will follow up to discuss details and answer any questions."
                  },
                ].map((item) => (
                  <div className="col-md-6 mb-3" key={item.number}>
                    <div className="d-flex align-items-start">
                      <div
                        className={`${item.bg} text-white rounded-circle d-flex align-items-center justify-content-center me-3`}
                        style={{ width: 40, height: 40, minWidth: 40 }}
                      >
                        <span className="fw-bold">{item.number}</span>
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1">{item.title}</h6>
                        <p className="text-muted mb-0">{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body text-center">
                  <i className="fa-solid fa-phone fa-2x text-primary mb-3"></i>
                  <h5 className="card-title">Need to Talk?</h5>
                  <p className="card-text">Call us directly for immediate assistance</p>
                  <a href="tel:8553652229" className="btn btn-outline-primary">
                    <i className="fa-solid fa-phone me-2"></i>855-365-2229
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body text-center">
                  <i className="fa-solid fa-envelope fa-2x text-success mb-3"></i>
                  <h5 className="card-title">Email Support</h5>
                  <p className="card-text">Send us your questions anytime</p>
                  <a href="mailto:support@workgear365.com" className="btn btn-outline-success">
                    <i className="fa-solid fa-envelope me-2"></i>support@workgear365.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="text-center">
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <Link to="/" className="btn btn-primary btn-lg">
                <i className="fa-solid fa-home me-2"></i>Return to Homepage
              </Link>
              <Link to="/quotes" className="btn btn-outline-primary btn-lg">
                <i className="fa-solid fa-plus me-2"></i>Submit Another Quote
              </Link>
              {user && (
                <Link to="/my-quotes" className="btn btn-outline-secondary btn-lg">
                  <i className="fa-solid fa-history me-2"></i>View My Quotes
                </Link>
              )}
            </div>
          </div>

          {/* Business Hours */}
          <div className="alert alert-info mt-5">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h6 className="alert-heading mb-1">
                  <i className="fa-solid fa-clock me-2"></i>Business Hours
                </h6>
                <p className="mb-0">Monday - Saturday: 8:00 AM - 5:00 PM (EST)</p>
              </div>
              <div className="col-md-4 text-md-end">
                <small className="text-muted">
                  <i className="fa-solid fa-info-circle me-1"></i>
                  Response within 24 business hours
                </small>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Inline styles for card hover */}
      <style>{`
        .card {
          transition: transform 0.2s ease-in-out;
        }
        .card:hover {
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default QuoteSuccess;
